import React, { useEffect } from 'react'
import { useAuth } from '../../core/AuthContext'
import { useAxios } from '../../core/AxiosContext'
import { useGlobal, useGlobalDispatch } from '../../core/GlobalContext'
import { DOCUMENT_URL_STATUS } from '../../core/actions'
import { getDocUrlsAction } from './DocumentsDuck'
import { fetchFinancierAction } from './FinancierDuck'

export const Documents = ({ children }) => {
  const { authState } = useAuth()
  const { authAxios } = useAxios()
  const { financierDispatch, documentsDispatch } = useGlobalDispatch()

  const {
    documentsState: { docUrlMap },
  } = useGlobal()

  // TODO wrapper in axios that parses document ids from all responses.

  // Fetched financier details once per page reload
  useEffect(() => {
    fetchFinancierAction()(authAxios, financierDispatch, documentsDispatch)
  }, [authState.accessToken])

  useEffect(() => {
    // Returns map of all document Ids that needs its resp. url
    const extractedIds = Object.entries(docUrlMap)
      .map(([key, val]) => {
        if (val.status !== DOCUMENT_URL_STATUS.success) {
          return key
        }
      })
      .filter(Boolean)

    console.log('Extracted document Ids', extractedIds)
    extractedIds?.length > 0 && getDocUrlsAction(extractedIds)(authAxios, documentsDispatch)
  }, [docUrlMap])

  return <>{children}</>
}
